export const MEDIA = {
  hero: "/hero-women.jpg",
  community: "https://images.unsplash.com/photo-1758798458635-f01402b40919?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&ixlib=rb-4.1.0",
  mobility: "https://images.unsplash.com/photo-1758599880540-8150399824f0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&ixlib=rb-4.1.0",
  walking: "https://images.unsplash.com/photo-1655070834893-b7ec21108a9f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&ixlib=rb-4.1.0",
  protein: "https://images.unsplash.com/photo-1572424117831-005b5e9b3ae4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&ixlib=rb-4.1.0",
};

// Category slug -> hero image
export const CATEGORY_IMG = {
  "strength-and-muscle": MEDIA.hero,
  "walking-and-cardio": MEDIA.walking,
  "mobility-and-flexibility": MEDIA.mobility,
  "nutrition-and-protein": MEDIA.protein,
  "menopause-and-fitness": MEDIA.community,
  "motivation-and-accountability": MEDIA.community,
  "weight-management": MEDIA.protein,
  "home-workouts": MEDIA.mobility,
  "start-again": MEDIA.walking,
  "success-stories": MEDIA.community,
};

// Guide image_key -> image
export const GUIDE_IMG = {
  hero: MEDIA.hero,
  community: MEDIA.community,
  mobility: MEDIA.mobility,
  protein: MEDIA.protein,
  walking: MEDIA.walking,
};
